// Correspondence: friendly attributes (family size / house type / age / income)
// -> Dividual subsegments. This is DISTRITOOL'S OWN TABLE, read from its API
// (POST PROMDividual/Get) on 2026-10-15 by sampling every picker flag, every age
// year and every income index point — so the pickers here yield exactly the
// subsegments Distritool yields. See docs/distritool-dividuals.md.
//
// Dimensions:
//   family:  'singles' | 'couples' | 'small_families' | 'single_parents'
//            (Distritool: isSingleNoChildren / isCoupleNoChildren / isCoupleWithChildren / isSingleWithChildren)
//   house:   'apartment' | 'enclosed' | 'half_open' | 'detached' | 'big_house'
//            (Distritool: isAppartment / isTwoSidedHouse / isThreeSidedHouse / isFourSidedHouse / isLargeHouse)
//   age:     [lo, hi] — Distritool matches when the chosen age range CONTAINS lo OR hi
//            (an endpoint test, not an overlap test; kept identical on purpose)
//   income:  one index value, 100 = modal income (€ 4,076 gross/month); matches when the
//            chosen income range contains it. Distritool's slider runs to 2x modal (200).

export const SUBSEGMENTS = [
  { code: 'A01', family: ['small_families'], house: ['apartment'], age: [25, 44], income:  70 }, // Inner-city renters with toddlers
  { code: 'A02', family: ['singles'], house: ['enclosed'], age: [35, 49], income:  65 }, // Single renters in terraced house
  { code: 'A03', family: ['singles'], house: ['enclosed'], age: [50, 64], income:  70 }, // Middle-aged renters with garden
  { code: 'B04', family: ['singles'], house: ['apartment', 'enclosed'], age: [19, 29], income:  60 }, // Young singles in apartment
  { code: 'B05', family: ['singles', 'couples'], house: ['apartment', 'enclosed'], age: [25, 35], income:  75 }, // Modest urban youths
  { code: 'B06', family: ['singles', 'couples'], house: ['apartment', 'enclosed'], age: [25, 35], income:  70 }, // Dynamic urban youths
  { code: 'B07', family: ['singles', 'couples'], house: ['enclosed'], age: [25, 34], income:  80 }, // Young in a cosy terraced house
  { code: 'C08', family: ['single_parents', 'small_families'], house: ['apartment', 'enclosed'], age: [30, 49], income:  70 }, // Young urban families
  { code: 'C09', family: ['small_families'], house: ['enclosed'], age: [30, 49], income:  90 }, // Young suburban families
  { code: 'D10', family: ['single_parents', 'small_families'], house: ['apartment', 'enclosed'], age: [45, 59], income:  85 }, // Families with teenagers in social housing
  { code: 'D11', family: ['singles'], house: ['half_open', 'detached'], age: [45, 59], income:  98 }, // End of career in modest house
  { code: 'E12', family: ['singles', 'couples'], house: ['enclosed'], age: [60, 74], income:  90 }, // Young seniors in allotment
  { code: 'E13', family: ['singles'], house: ['enclosed'], age: [60, 79], income:  80 }, // Active seniors in terraced house
  { code: 'E14', family: ['singles', 'couples'], house: ['apartment'], age: [65, 65], income:  85 }, // Seniors in flat
  { code: 'E15', family: ['singles', 'couples'], house: ['enclosed'], age: [65, 65], income:  90 }, // Seniors in modest house
  { code: 'E16', family: ['singles', 'couples'], house: ['apartment'], age: [70, 70], income:  75 }, // Seniors in shopping street apartment
  { code: 'E17', family: ['singles', 'couples'], house: ['enclosed', 'half_open'], age: [80, 80], income:  85 }, // Older seniors with garden
  { code: 'F18', family: ['couples'], house: ['half_open', 'detached'], age: [25, 44], income: 115 }, // Young rural couples in newbuild
  { code: 'F19', family: ['single_parents', 'couples'], house: ['enclosed'], age: [25, 44], income: 110 }, // Young couples in renovated house
  { code: 'F20', family: ['small_families'], house: ['half_open', 'detached'], age: [30, 49], income: 115 }, // Commuters with toddlers
  { code: 'F21', family: ['small_families'], house: ['detached'], age: [35, 54], income: 120 }, // Residential families with kids
  { code: 'F22', family: ['small_families'], house: ['detached'], age: [30, 54], income: 125 }, // Residential families with teenagers
  { code: 'G23', family: ['small_families'], house: ['enclosed'], age: [35, 54], income:  98 }, // Dynamic urban families
  { code: 'G24', family: ['single_parents', 'singles'], house: ['detached'], age: [40, 59], income: 110 }, // Rural single parents
  { code: 'G25', family: ['small_families'], house: ['detached'], age: [50, 64], income: 125 }, // Older families in a comfortable house
  { code: 'G26', family: ['singles', 'couples'], house: ['enclosed'], age: [50, 74], income: 105 }, // Urban empty nesters
  { code: 'G27', family: ['couples'], house: ['half_open', 'detached'], age: [55, 74], income: 110 }, // Rural empty nesters
  { code: 'H28', family: ['singles', 'couples'], house: ['detached'], age: [60, 60], income: 120 }, // Prosperous villa district seniors
  { code: 'H29', family: ['singles', 'couples'], house: ['detached'], age: [65, 65], income: 125 }, // Prosperous rural seniors
  { code: 'H30', family: ['singles', 'couples'], house: ['half_open'], age: [75, 75], income: 105 }, // Older seniors in villa district
  { code: 'I31', family: ['singles', 'couples'], house: ['enclosed', 'half_open'], age: [35, 54], income: 120 }, // Career makers in residential neighbourhood
  { code: 'I32', family: ['small_families'], house: ['half_open', 'detached'], age: [35, 54], income: 125 }, // Entrepreneurial families with children
  { code: 'I33', family: ['small_families'], house: ['detached'], age: [35, 59], income: 135 }, // Entrepreneurial families in recent villa
  { code: 'I34', family: ['couples'], house: ['big_house'], age: [50, 69], income: 145 }, // End of career in luxury house
  { code: 'J35', family: ['small_families'], house: ['big_house'], age: [35, 54], income: 150 }, // Young successful entrepreneurial families
  { code: 'J36', family: ['small_families'], house: ['big_house'], age: [40, 59], income: 155 }, // Prosperous entrepreneurial families
  { code: 'J37', family: ['small_families'], house: ['big_house'], age: [40, 59], income: 200 }, // Wealthy families in affluent neighbourhood
];

const BY_CODE = Object.fromEntries(SUBSEGMENTS.map(s => [s.code, s]));

export const AGE_MIN = 18, AGE_MAX = 90;
export const INCOME_MIN = 25, INCOME_MAX = 200; // index; the full range = no income constraint

// Legacy saved selections (before 2026-10-15) stored income as tiers 0/1/2. Map them onto the
// index scale: Minimum ≤ 90, Modal 91–130, 2x modal ≥ 131 (the natural clusters of the table).
const TIER_RANGES = { 0: [0, 90], 1: [91, 130], 2: [131, 300] };
export function tiersToIncomeRange(tiers) {
  const t = [...tiers].map(Number).filter(n => TIER_RANGES[n]);
  if (!t.length) return null;
  return [Math.min(...t.map(n => TIER_RANGES[n][0])), Math.max(...t.map(n => TIER_RANGES[n][1]))];
}

/**
 * Given the friendly-picker selection, return the corresponding subsegment codes, with
 * Distritool's rules: a subsegment matches when it satisfies EVERY dimension the user has set
 * (AND across dimensions, OR within one). Dimensions left untouched impose no constraint; a
 * range spanning its full domain counts as untouched.
 *
 * sel = {
 *   familySizes: Set<string>,          // empty = any
 *   houseTypes:  Set<string>,          // empty = any
 *   ageRange:    [lo, hi] | null,
 *   incomeRange: [lo, hi] | null,      // income index
 *   incomeLevels: Set<0|1|2>           // legacy tiers, used only when incomeRange is absent
 * }
 */
export function correspondingSubsegments(sel = {}) {
  const fam = sel.familySizes instanceof Set ? sel.familySizes : new Set(sel.familySizes || []);
  const house = sel.houseTypes instanceof Set ? sel.houseTypes : new Set(sel.houseTypes || []);
  const age = (Array.isArray(sel.ageRange) && (sel.ageRange[0] > AGE_MIN || sel.ageRange[1] < AGE_MAX))
    ? sel.ageRange : null;
  let inc = null;
  if (Array.isArray(sel.incomeRange)) {
    if (sel.incomeRange[0] > INCOME_MIN || sel.incomeRange[1] < INCOME_MAX) inc = sel.incomeRange;
  } else if (sel.incomeLevels) {
    inc = tiersToIncomeRange(sel.incomeLevels);
  }

  const anySet = Boolean(fam.size || house.size || age || inc);

  const out = [];
  for (const s of SUBSEGMENTS) {
    let score = 0;
    if (fam.size) {
      if (!s.family.some(f => fam.has(f))) continue;
      score++;
    }
    if (house.size) {
      if (!s.house.some(h => house.has(h))) continue;
      score++;
    }
    if (age) {
      const inRange = (v) => v >= age[0] && v <= age[1];
      if (!inRange(s.age[0]) && !inRange(s.age[1])) continue;
      score++;
    }
    if (inc) {
      if (s.income < inc[0] || s.income > inc[1]) continue;
      score++;
    }
    out.push({ code: s.code, score });
  }
  // No pickers touched => nothing "corresponds" yet (UI shows the full catalogue instead).
  return { any: Boolean(anySet), matched: out.sort((a, b) => b.score - a.score) };
}

export function subsegmentMeta(code) { return BY_CODE[code] || null; }
